import { connect } from 'react-redux'
// import { bindActionCreators } from 'redux'
import AssociarClienteExistente from './associarClienteExistente'

// const mapDispatchToProps = dispatch =>
//   bindActionCreators(actions, dispatch)

export default connect(
  // mapDispatchToProps
)(AssociarClienteExistente);
